<template>
	<div>
		<el-card shadow="never">
			<el-form ref="form" :inline="true" :model="formData" :rules="rules" label-width="100px" size="small">
				<el-form-item label="项目">
						<el-input size="small" v-model="formData.projectName" placeholder="项目" :readonly="true"></el-input>
					</el-form-item>
					<el-form-item label="一级分类" prop="category">
						<el-select size="small" v-model="formData.category" placeholder="请选择一级分类" clearable>
							<el-option v-for="item in simpleMeterType" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="类型">
						<el-select size="small" v-model="formData.meterType" placeholder="请选择类型" clearable>
							<el-option v-for="item in meterType" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="精确度">
						<el-select size="small" v-model="formData.scale" placeholder="请选择精确度" clearable>
							<el-option v-for="item in scale" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="收费入口">
						<el-radio-group v-model="formData.mergeFlag">
							<el-radio v-for="item in mergeFlag" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>

			<div class="form-buttons-center">
				<el-button size="small" type="primary" :loading="saveLoading" @click="doSaveFeeitem">确 定</el-button>
				<el-button size="small" @click="doClose">取 消</el-button>
			</div>
		</el-card>
	</div>
</template>
<script>
import "@/assets/scss/common.scss";
import dlgForm from "@/mixin/dlgForm";
import { simpleMeterType, meterType, mergeFlag, scale } from "@/dict/meterDict";
export default {
	name: "EditForm",
	mixins: [dlgForm],
	data() {
		return {
            simpleMeterType,
			meterType,
			mergeFlag,
			scale,
			rules: {
				category: [
					{ required: true, message: "请选择一级分类", trigger: "blur" },
				],
                meterType: [
					{ required: true, message: "请选择类型", trigger: "blur" },
				],
                scale: [
					{ required: true, message: "请选择精确度", trigger: "blur" },
				],
			},
		};
	},
	methods: {
        doSaveFeeitem() {
            const url = "meter/web/feeitem/save";
            this._doSaveForm(this.$refs.form, url, 'POST');
		},
	}
};
</script>